/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReportingIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <rect x="0.5" y="0.5" width="23" height="15" />
      <path d="M11.5,15.5 L11.5,18.5" />
      <polyline points="6.5 23.5 11.5 18.5 16.5 23.5" />
      <polyline points="2.5 8.5 6.5 8.5 8.5 6 10.5 10.5 13 7.5 15 9.5 18.5 4.5" />
      <rect x="2.5" y="2.5" width="19" height="11" />
    </g>
  </svg>
);

export default ReportingIcon;
